import React from "react";
import styles from './PasswordValidation.module.scss';
import CheckIcon from '@material-ui/icons/Check';
import ClearIcon from '@material-ui/icons/Clear';

const PassowordValidation = ({ password }) => {
    return (
        <small className={styles['password-error']}>
            <span className={styles.label}>The password must:</span>
            <ul className={styles.list}>
            <li>{ (password && (password.length >= 8)) ?
                <span className={styles.correct}><CheckIcon /> Be at least 8 characters long</span> :
                <span className={styles.incorrect}><ClearIcon /> Be at least 8 characters long</span>}</li>
            <li>{ password && /[a-z]/.test(password) ?
                <span className={styles.correct}><CheckIcon /> Include at least 1 lowercase letter</span> :
                <span className={styles.incorrect}><ClearIcon /> Include at least 1 lowercase letter</span>}</li>
            <li>{ password && /[A-Z]/.test(password) ?
                <span className={styles.correct}><CheckIcon /> Include at least 1 capital letter</span> :
                <span className={styles.incorrect}><ClearIcon /> Include at least 1 capital letter</span>}</li>
            <li>{ password && /\d/.test(password) ?
                <span className={styles.correct}><CheckIcon /> Include at least 1 number</span> :
                <span className={styles.incorrect}><ClearIcon /> Include at least 1 number</span>}</li>
            <li>{ password && /[!@#$%^&*]/.test(password) ?
                <span className={styles.correct}><CheckIcon /> Include at least 1 special character (!@#$%^&*)</span> : 
                <span className={styles.incorrect}><ClearIcon /> Include at least 1 special character (!@#$%^&*)</span>}</li>
            </ul>
        </small>
    )
};

export default PassowordValidation;
